export default {
  meta: {
    title: '商圈管理',
  },
};
